import { render } from "./ServicesView.vue?vue&type=template&id=5bc78eb3&scoped=true"
const script = {}

import "./ServicesView.vue?vue&type=style&index=0&id=5bc78eb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc78eb3"]])

export default __exports__